import { render, staticRenderFns } from "./NewsletterList.vue?vue&type=template&id=4e8fe226&"
import script from "./NewsletterList.vue?vue&type=script&lang=js&"
export * from "./NewsletterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports